module.exports = __webpack_public_path__ + "static/media/qa-featured.6ebf9a85.jpg";